import { useAuthContext } from "@contexts/authContext"
import { size } from "@styles/theme"
import styled from "@emotion/styled"
import AccountUserInformationSection from "@components/account_settings/AccountUserInformationSection"
import AccountActionsSection from "@components/account_settings/AccountActionsSection"
import AccountLogoutSection from "@components/account_settings/AccountLogoutSection"
import BackTopbar, { TopbarClearfix } from "@elements/BackTopbar"
import ScreenContainer from "./ScreenContainer"

const BottombarClearfix = styled.div`
  height: ${size(15)};
  flex-shrink: 0;
  width: 100%;
`

const SettingsContainer = styled.div`
  position: abolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100dvw;
  height: 100dvh;
  padding: 0 ${size(5)};
  overflow-y: scroll;
  overflow-x: hidden;
`

const Settings = () => {
  const { state: authState } = useAuthContext()

  return(
    <ScreenContainer style={{ position: 'absolute', height: '100dvh', width: '100dvw' }}>
      <BackTopbar title='Account Settings' />
      <SettingsContainer>
        <TopbarClearfix />
        {!authState?.user?.isAnonymous && <AccountLogoutSection />}
        {!authState?.user?.isAnonymous && <AccountUserInformationSection />}
        {<AccountActionsSection />}
        <BottombarClearfix />
      </SettingsContainer>
    </ScreenContainer>
  )
}

export default Settings
